import React from "react";
import { defaultDropList, defaultAttributeList } from "../Data/WBComponentDefaults";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { WBComponent } from "./WBComponent";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import WebDesigner from "../WebDesigner";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";
import { BusienssControlNames, GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import { NodeCSSClassDefinition } from "./NodeGlobalStyleGenerator";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import { AlignCenterHorizontal, AlignLeft, AlignRight } from "../Icons/AlignmentIcons";


export default class BusinessOwner extends WBComponent {
    constructor() {
        super();
        this.typename = wBComponentTypeNames.businessOwnerName;
        this.displayName = "Business List";
        this.dropList = defaultDropList;
        this.colorFields = ["color","ownerImgBorderColor","panelColor","panelBorder","2ndPanelColor","2ndTxtColor","ownerSocialColor","ownerSocialBGColor"];

        this.primaryEditAttributes = ["clickpage","clickpage2","ownerLayout","useService","ownerCardAlignment","panelRadius","panelBWidth", "ownerImgRadius","ownerImgBorder", "ownerImgShadow","ownerSocialRadius"];
        this.editList = [...this.primaryEditAttributes,...this.colorFields,"clickpage","clickpage2",...this.colorFields,"panelBWidth","panelRadius","2ndTxtColor", "2ndPanelColor", "ownerImgBorder", "ownerImgBorderColor", "ownerLayout", "ownerImgRadius", "ownerImgShadow", ...defaultAttributeList, attributeTypes.gap, componentAttributeTypes.visibility, componentAttributeTypes.customCSS];
        this.contentEditable = false;
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 512 512"><path d="M384 48c8.8 0 16 7.2 16 16l0 384c0 8.8-7.2 16-16 16L96 464c-8.8 0-16-7.2-16-16L80 64c0-8.8 7.2-16 16-16l288 0zM96 0C60.7 0 32 28.7 32 64l0 384c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L96 0zM240 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM512 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64zM496 192c-8.8 0-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64c0-8.8-7.2-16-16-16zm16 144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16l0-64z"/></svg>
           this.cssDefinitions = [
            new NodeCSSClassDefinition(".staff-image-border",
                [
                    { key: "ownerImgBorder", cssProperty: "border-width", default: "0" },

                    { key: "ownerImgBorderColor", cssProperty: "border-color", default: "" },
                    { key: "X", cssProperty: "border-style", default: "solid" },
                    { key: "ownerImgRadius", cssProperty: "border-radius", default: "" },
                    { key: "ownerImgShadow", cssProperty: "box-shadow", default: "" }
                ]),
                new NodeCSSClassDefinition(".staff-image-border",
                    [
                        { key: "ownerImgBorder", cssProperty: "border-width", default: "0" },

                        { key: "ownerImgBorderColor", cssProperty: "border-color", default: "" },
                        { key: "X", cssProperty: "border-style", default: "solid" },
                        { key: "ownerImgRadius", cssProperty: "border-radius", default: "" },
                        { key: "ownerImgShadow", cssProperty: "box-shadow", default: "" }
                    ]),


            new NodeCSSClassDefinition(".business-list-card", [
                { key: "panelColor", cssProperty: "background-color", default: "var(--theme-color-6)" },
                { key: "panelRadius", cssProperty: "border-radius", default: "" },
                { key: "panelBorder", cssProperty: "border-color", default: "var(--theme-color-1)" },
                { key: "panelBWidth", cssProperty: "border-width", default: "0px" },

                { key: "x", cssProperty: "border-style", default: "solid" }
            ]),
            new NodeCSSClassDefinition(".b-list-content", [

                { key: "ownerCardAlignment", cssProperty: "align-items", default: "" },

            ]),
            new NodeCSSClassDefinition(".business-profile-text", [

                { key: "ownerCardAlignment", cssProperty: "align-items", default: "" },

            ]),
            new NodeCSSClassDefinition(".b-type-chip", [
                { key: "2ndPanelColor", cssProperty: "background-color", default: "var(--theme-color-4)"  },
                { key: "2ndTxtColor", cssProperty: "color", default: ""  },
                { key: "panelColor", cssProperty: "border-color", default: ""  }
            ]),
            new NodeCSSClassDefinition(".suite", [
                { key: "2ndTxtColor", cssProperty: "color", default: ""  },

            ]),
            // new NodeCSSClassDefinition(".service-search-feild", [
            //     { key: "useService", cssProperty: "display", default: ""  },

            // ]),

            new NodeCSSClassDefinition(".book-row", [
                { key: "2ndPanelColor", cssProperty: "background-color", default: "var(--theme-color-4)"  },
                { key: "panelRadius", cssProperty: "border-bottom-right-radius", default: "" },
                { key: "panelRadius", cssProperty: "border-bottom-left-radius", default: "" },
                { key: "2ndTxtColor", cssProperty: "color", default: ""  },
            ]),
            new NodeCSSClassDefinition(".social-icon", [
                { key: "ownerSocialColor", cssProperty: "color", default: ""  },
                { key: "ownerSocialBGColor", cssProperty: "background", default: "" },
                { key: "ownerSocialRadius", cssProperty: "border-radius", default: "4px" },
                {key:"x",cssProperty:"padding",default:"7px"},
                {key:"x",cssProperty:"width",default:"26px"},
                {key:"x",cssProperty:"height",default:"26px"}

            ]),

            new NodeCSSClassDefinition(".staff-initials", [
                { key: "2ndPanelColor", cssProperty: "background-color", default: "var(--theme-color-4)"  },
                { key: "2ndTxtColor", cssProperty: "color", default: ""  },
            ])
        ]

    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [
            new AttributeDefinition("ownerLayout", "Location", "", AttributeInputType.ButtonField,
                [
                    { label: "Current", value: "" },
                    { label: "All", value: "2" },
                ]),
                new AttributeDefinition("useService", "Search by Services", "", AttributeInputType.ButtonField,
                    [
                        { label: "On", value: "" },
                        { label: "Off", value: "none" },
                    ]),

            new AttributeDefinition("clickpage2", "On Dormant Direct To", "", AttributeInputType.DuplicatedPageSelectField),

            new AttributeDefinition("ownerImgBorder", "Image Border Width", "", AttributeInputType.FourwayMeasurmentField,
                [
                    { label: "Auto", value: "" },
                    { label: "S", value: "1px" },
                    { label: "M", value: "3px" },
                    { label: "L", value: "6px" }

                ], { min: 0, max: 20, step: 1, unit: "px", default: 0 }),
                new AttributeDefinition("panelBWidth", "Panel Border Width", "", AttributeInputType.FourwayMeasurmentField,
                    [
                        { label: "Auto", value: "" },
                        { label: "S", value: "1px" },
                        { label: "M", value: "3px" },
                        { label: "L", value: "6px" }

                    ], { min: 0, max: 20, step: 1, unit: "px", default: 0 }),

            new AttributeDefinition("ownerImgBorderColor", "Image Border Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("2ndPanelColor", "Accent Color", "", AttributeInputType.ColorField),
            new AttributeDefinition("2ndTxtColor", "Accent Text", "", AttributeInputType.ColorField),
            new AttributeDefinition("ownerCardAlignment", "Card Alignment", "", AttributeInputType.ButtonField,[
                {label:"Auto",value:""},
                {label:<AlignLeft/>,value:"flex-start"},
                {label:<AlignCenterHorizontal/>,value:"center"},
                {label:<AlignRight/>,value:"flex-end"},
            ]),
            new AttributeDefinition("ownerImgRadius", "Image Border Radius", "", AttributeInputType.MeasurementField,
                [
                    { label: "Auto", value: "" },
                    { label: "S", value: "4px" },
                    { label: "M", value: "20px" },
                    { label: "L", value: "40px" }

                ], { min: 0, max: 200, step: 1, unit: "px", default: 0 }),

            new AttributeDefinition("ownerImgShadow", "Image Shadow", "", AttributeInputType.ShadowField,
                [
                    { label: "Auto", value: "" },
                    { label: "Off", value: "none" },
                   { label: "S", value: "0px 2px 16px 6px #00000044" },
                    { label: "M", value: "0px 3px 32px 8px #00000066" },
                    { label: "L", value: "0px 4px 48px 12px #00000088" },


                ]) ,

            new AttributeDefinition("ownerSocialColor", "Social Color", "", AttributeInputType.ColorField) ,
            new AttributeDefinition("ownerSocialBGColor", "Social BG", "", AttributeInputType.ColorField) ,
            new AttributeDefinition("ownerSocialRadius", "Social Border Radius", "", AttributeInputType.MeasurementField,
                [
                    { label: "Auto", value: "" },
                    { label: "S", value: "2px" },
                    { label: "M", value: "4px" },
                    { label: "L", value: "8px" }], { min: 0, max: 100, step: 1, unit: "px", default: 0 }),
        ]




    }
    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        // thisLayout.screenSizeStyleAttributes[ScreenSize.Desktop] = {gap:"16px"};
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);

    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {

        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        const atts = GetNodeDomAttributes("flex-column max-w-100 min-w-350 clamp-height scrollable w-full vb-control resizable-container", component, screenSize, isEditor);

        const layoutId = getNodeComponentAttributeValue(component, "ownerLayout", "1");
        const hideServices = getNodeComponentAttributeValue(component, "useService", "");



        let pageId = getNodeComponentAttributeValue(component, "clickpage", "");
        let pageId2 = getNodeComponentAttributeValue(component, "clickpage2", "");
        let url = "";
        let url2 = "";

        let foundPage = null;
        if (pageId.length > 2) {
            for (let i = 0; i < siteData.pages.length; i++) {

                let page = siteData.pages[i];
                if (page.pageId == pageId) {
                    foundPage = page;
                    url = page.url;

                }

                if (page.children) {
                    for (let ii = 0; ii < page.children.length; ii++) {
                        let child = page.children[ii];
                        if (child.pageId == pageId) {
                            foundPage = child;
                            url = child.url;
                        }
                    }
                }

                if (url.length > 1) {
                    break;
                }
            }
        }

        if (foundPage && !foundPage.isDuplicateAllLocationPage) { //no longer a duplicated page so reset it
            url = "";
            setNodeComponentAttributeValue(component, "clickpage", "");
        }

        if (url.length < 1) {
            url = ".";
        }


        foundPage = null;
        if (pageId2.length > 2) {
            for (let i = 0; i < siteData.pages.length; i++) {

                let page = siteData.pages[i];
                if (page.pageId == pageId2) {
                    foundPage = page;
                    url2 = page.url;

                }

                if (page.children) {
                    for (let ii = 0; ii < page.children.length; ii++) {
                        let child = page.children[ii];
                        if (child.pageId == pageId2) {
                            foundPage = child;
                            url2 = child.url;
                        }
                    }
                }

                if (url2.length > 1) {
                    break;
                }
            }
        }

        if (foundPage && !foundPage.isDuplicateAllLocationPage) { //no longer a duplicated page so reset it
            url2 = "";
            setNodeComponentAttributeValue(component, "clickpage2", "");
        }

        if (url2.length < 1) {
            url2 = ".";
        }


        if (!isEditor) {
            //es linting warning about missing content which will be filled by the business placeholder
            // eslint-disable-next-line
            return <> <a id="owner-click-link" href={url} style = {{display:"none"}} ></a>
                    <a id="owner-click-link2" href={url2} style = {{display:"none"}} ></a>
            <BusinessPlaceHolder dataKey={BusienssControlNames.OwnerName} layout={layoutId} node={component} classNames={atts.className} inFilter={hideServices} />

            </>
        }

        return (
            <>
            <div {...atts} {...GetLocationHoverAtt(component, siteData)}>

                <style>
                    {super.GetComponentGlobalCSS(component, isEditor)}
                </style>
                <GenericBusinessControl key={component.id + bid} bLocationId={bid} layout={layoutId} filters={hideServices} dataKey={"ownername"} node={component} userContext={siteData} />
                </div>
            </>

        )
    }

}
